import { useState, useEffect } from 'react';

export function useOnlineStatus() {
  // Always return true - the offline detection doesn't work reliably on iOS Capacitor
  // Network errors will be handled by individual API calls
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Force true for now to prevent false positives
  return true;
}
